import { useState } from 'react';

import ApiHandlers from './ApiHandlers';
import Main from '../components/Main';
import TestingPopup from '../components/TestingPopup';

const AppContainer = (props) => {
  // INTERNAL STATE OF THE APPLICATION
  const [state, setState] = useState({ values: {}, info: {}, slots:{}});
  const [testingPopupOpen, setTestingPopupOpen] = useState(false);

  return (
    <ApiHandlers setState={setState} {...props}>
      <Main
        state={state}
        setState={setState}
        appConfig={{ idPushTTL: props.idPushTTL, idJourney: props.idJourney, eventDefinitionKey: props.eventDefinitionKey, version: props.version }}
        openTestingPopup={() => setTestingPopupOpen(true)}
        setAppConfig={props.setAppConfig}
      />
      {testingPopupOpen ? (
        <TestingPopup 
          updateAppConfig={props.updateAppConfig}
          close={() => setTestingPopupOpen(false)}
          setAppConfig={props.setAppConfig}
        />
      ) : ''}
  </ApiHandlers>);
}

export default AppContainer;